import React from 'react';
import { func, bool } from 'prop-types';
import { SurveySchemaPartItemEditorType } from '../../../../constants/types';
import styles from './instructionText.module.css';
import { withLang } from '../../../../i18n';
import { LocalizedRichTextArea } from '../../../LocalizedInput';

const InstructionText = ({
  item,
  onRemove,
  onLocalizedInstructionTextInputChange,
  lockedFromEditing, translate: t
}) => (
  <div>
    <div className={styles.itemHeader}>
      <button
        type="button"
        className="actionButton icon--trash iconRemove"
        onClick={onRemove}
        title={t('common.remove')}
        disabled={lockedFromEditing}
      />
    </div>
    <LocalizedRichTextArea
      name="text"
      values={item.staticText.text}
      onInputChange={onLocalizedInstructionTextInputChange}
      placeholderTranslationNamespace="inLanguage"
    />
  </div>
);

InstructionText.propTypes = {
  item: SurveySchemaPartItemEditorType.isRequired,
  onRemove: func.isRequired,
  onLocalizedInstructionTextInputChange: func.isRequired,
  lockedFromEditing: bool.isRequired,
  translate: func.isRequired
};

export default withLang(InstructionText);
